// extracted by mini-css-extract-plugin
export default {"languageSelect":"workflow-details-container__language-select__SX4zF"};